import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=5a7028c9&"
import script from "./PageNotFound.vue?vue&type=script&lang=ts&"
export * from "./PageNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=5a7028c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports